module.exports = __webpack_public_path__ + "static/media/cd2-icon-total.c1d7634f.svg";